import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, } from 'antd';
import { Row, Col, Modal } from "antd";
import { color } from "../utils/themes/color";
import {
    UserOutlined,
    BankOutlined,
    UserAddOutlined,
    UserSwitchOutlined,
    SettingOutlined,
    BorderOuterOutlined,
    HeatMapOutlined,
    BulbOutlined,
    ExperimentOutlined,
    SlidersOutlined,
    PaperClipOutlined,
    PoweroffOutlined,
    MergeCellsOutlined,
    DropboxOutlined,
    EditOutlined,
    AppstoreAddOutlined,
    PlusCircleOutlined,
    UnorderedListOutlined,
    DollarOutlined,
    BookOutlined,
    ArrowUpOutlined,
    RetweetOutlined,
    GiftOutlined,
    CommentOutlined,
    NotificationOutlined
} from '@ant-design/icons';
import UserList from "./users/userList/userList";
import CreateUser from "./users/createUser/createUser";
import CoachProfile from "./users/userProfile/coachProfile";
import AthleteProfile from './users/userProfile/athleteProfile';
import SportList from "./defaultSettings/sports";
import CategoriesList from "./defaultSettings/categories";
import Goals from "./defaultSettings/goals";
import Equipments from "./defaultSettings/equipments";
import Sleep from "./defaultSettings/sleep";
import Sickness from "./defaultSettings/sickness";
import Jobs from "./defaultSettings/job";
import Inactions from "./defaultSettings/inactions";
import Requests from "./requests";
import Notification from "./notification";
import Logout from "./logout";
import './container.css'
import Movements from "./movements";
import Edit from "./movements/edit";
import EditMovements from "./movements/editMovements";
import Skills from "./defaultSettings/skills";
import Packages from "./defaultSettings/packages";
import Identification from "./defaultSettings/identification";
import Transactions from "./transactions";
import Dashboard from "./dashboard";
import Wallet from "./transactions/wallet";

export default function Container() {


    const { Header, Content, Sider } = Layout;
    const [collaps, setCollaps] = useState(false);
    const location = useLocation().pathname;
    const navigate = useNavigate();

    const Render = (location) => {
        switch (location) {
            
            case "/users": return <UserList />
            case "/create-user": return <CreateUser />
            case "/coach": return <CoachProfile />
            case "/athlete": return <AthleteProfile />
            case "/sport-list": return <SportList />
            case "/categories-list": return <CategoriesList />
            case "/goals-list": return <Goals />
            case "/equipments": return <Equipments />
            case "/sleep": return <Sleep />
            case "/sickness": return <Sickness />
            case "/jobs": return <Jobs />
            case "/movements": return <Movements />
            case "/movements/edit": return <Edit />
            case "/movements/editMovements": return <EditMovements />
            case "/inactions": return <Inactions />
            case "/requests": return <Requests />
            case "/notification": return <Notification/>
            case "/logout": return <Logout />
            case "/skills": return <Skills />
            case "/packages": return <Packages />
            case "/dashboard": return <Dashboard />
            case "/identification": return <Identification />
            case "/transaction-list": return <Transactions />
            case "/transactions/wallet": return <Wallet />
        }
    }

    function getItem(label, key, icon, children) {
        return { key, icon, children, label, };
    }

    const items = [
        getItem('داشبورد', '/dashboard', <BankOutlined />),
        getItem('کاربران', '1', <UserOutlined />, [
            getItem('لیست کاربران', '/users', <UserSwitchOutlined />),
            getItem('ایجاد کاربر جدید', '/create-user', <UserAddOutlined />),
        ]),
        getItem('تنطیمات پیش فرض', '2', <SettingOutlined />, [
            getItem('ورزش ها', '/sport-list', <BorderOuterOutlined />),
            getItem('هدف ها', '/goals-list', <HeatMapOutlined />),
            getItem('میزان خواب', '/sleep', <BulbOutlined />),
            getItem('بیماری ها', '/sickness', <ExperimentOutlined />),
            getItem('تجهیزات', '/equipments', <SlidersOutlined />),
            getItem('اطلاعات شغلی', '/jobs', <PaperClipOutlined />),
            getItem('مهارت ها', '/skills', <MergeCellsOutlined />),
            getItem('پکیج ها', '/packages', <DropboxOutlined />),
            getItem('کد معرف', '/identification', <GiftOutlined />),
            getItem('وضعیت غیر کاری', '/inactions', <PoweroffOutlined />),
            getItem('دسته بندی ها', '/categories-list', <UnorderedListOutlined />),

        ]),
        getItem('حرکات تمرینی', '3', <AppstoreAddOutlined />, [
            getItem('افزودن', '/movements', <PlusCircleOutlined />),
            getItem('ویرایش', '/movements/edit', <EditOutlined />),
        ]),
        getItem('تراکنش ها', '4', <RetweetOutlined />, [
            getItem('لیست تراکنش ها', '/transaction-list', <DollarOutlined />),
            getItem('لیست برداشت ها', '/transactions/wallet', <ArrowUpOutlined />),
        ]),
        getItem('درخواست ها', '/requests', <BookOutlined />),
        getItem('اعلانات', '/notification', <NotificationOutlined/>),


    ];

    if (localStorage.getItem('AccessToken') != null && localStorage.getItem('AccessToken') !== "" && localStorage.getItem('AccessToken') !== undefined) {
        return (
            <Layout style={{ height: window.innerHeight > 500 ? window.innerHeight : 600 }}>
                <Header style={{ margin: "5px", background: color.primaryContainer, border: `2px solid ${color.primary}`, borderRadius: "10px", textAlign: 'left' }}>
                    <Row style={{ display: 'flex', justifyContent: 'left', alignItems: 'left'}}>
                        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}>
                            <div style={{ cursor: "pointer", color: color.textColor }}
                                onClick={() => { navigate(`/logout`) }}>
                                <p>خروج</p>
                            </div>
                        </Col>
                    </Row>

                </Header>
                <Layout>
                    <Sider
                        collapsed={collaps}
                        width={250}
                        style={{ border: `2px solid ${color.primary}`, borderRadius: "10px", margin: "5px" }}>
                        <Menu
                            onClick={(e) => navigate(e.key)}
                            mode="inline"
                            theme="dark"
                            defaultSelectedKeys={location}
                            style={{ height: '100%', borderRight: 0, borderRadius: "10px", background: color.primaryContainer, overflow: 'scroll', color: color.textColor }}
                            items={items} />
                    </Sider>
                    <Layout
                        style={{ padding: '10px 5px', borderRadius: "10px" }}>
                        <Content
                            style={{ padding: 24, margin: 0, minHeight: 280, overflow: 'scroll' }}>
                            {Render(location)}
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        );
    }
    else {
        window.location.replace("/login");
    }
}



